module.exports = __webpack_public_path__ + "img/melegfoliazas.71d4e36f.jpg";